import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import type { SelectChangeEvent } from "@mui/material/Select";
import Select from "@mui/material/Select";
import { useFindAllClientsQuery } from "@/libs/generated/hooks";
import type { FindAllClientsQuery } from "@/libs/generated/operations";

type Client = FindAllClientsQuery["findAllClients"]["records"][number];

import { useState } from "react";

type Props = {
  onSelect: (client: Client | undefined) => void;
};

function ClientSelector({ onSelect }: Props) {
  const { data: clients = [] } = useFindAllClientsQuery(
    {
      GetAllInput: {
        keyword: "",
        pagination: { page: 0, perPage: 10 },
        sort: { field: "createdAt", order: "desc" },
        filter: { partner: true },
        include: { _count: true },
      },
    },
    { select: (data) => data.findAllClients.records }
  );
  const [client, setClient] = useState<Client | undefined>(undefined);
  const handleChange = (event: SelectChangeEvent) => {
    const client = clients.find((el) => String(el.id) === event.target.value);
    setClient(client);
    onSelect(client);
  };

  return (
    <Box sx={{ minWidth: 220 }}>
      <FormControl fullWidth>
        <InputLabel id="select-client">Choisir le mandataire</InputLabel>
        <Select
          labelId="select-client"
          id="select-client"
          value={client ? String(client.id) : ""}
          label="Choisir le mandataire"
          onChange={handleChange}
        >
          {clients.map((client: Client) => (
            <MenuItem key={client.id} value={client.id}>
              {client.assigneeFirstName} {client.assigneeLastName} ({client.name})
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default ClientSelector;
